import { MatchmakingMethodEnum } from '@Types';

export const isMatchmakingApplyFlow = (
  matchmakingMethod: MatchmakingMethodEnum | undefined,
): boolean => {
  if (!matchmakingMethod) {
    return false;
  }
  return [MatchmakingMethodEnum.APPLY, MatchmakingMethodEnum.APPLY_WITH_GROUP_FUND_MATCH].includes(
    matchmakingMethod,
  );
};
